import React, { useState, useEffect } from 'react';
import { getCategories } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const Categories = () => {
  const { t } = useTranslation('global');

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchCategories = async() =>{
    const response = await getCategories();
    console.log(response);
    setCategories(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' }

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth maxWidth="xl">
      <DataTable initialData={categories} columns={columns} entityName="categories" h2={t("list.categories")} />
    </Container>
  );
};

export default Categories;
